<template>
  <v-btn
    color="nitro"
    outlined
    download
    :small="isMobile"
    target="_blank"
    :href="module.ebook.file.url"
    @click="accessed_ebook(module.ebook.id)"
  >
    <img
      src="/images/icons/ebook-icon-download.svg"
      width="18px"
    >
    <span class="ml-2 first-letter-capitalize">
      Baixe o e-book
    </span>
  </v-btn>
</template>
<script>
import {accessed_ebook} from "@/student/api/Ebook";
import { mapGetters } from "vuex";
export default {
  computed:{
    ...mapGetters(['module']),
  },
  methods: {
    accessed_ebook,
  }
}
</script>
